import { filterType } from './types';

export enum SortByTypes {
  None = '',
  Date_ASC = 'publicationDate_asc',
  Date_DESC = 'publicationDate_desc',
  Likes = 'likes_desc',
  ReadTime_ASC = 'timeToRead_asc',
  ReadTime_DESC = 'timeToRead_desc',
  Alphabetically_ASC = 'title_asc',
  Alphabetically_DESC = 'title_desc',
  Author_ASC = 'author_asc',
  Author_DESC = 'author_desc',
}

export const slugIsFilter = (
  bestPractices: filterType,
  contentTypes: filterType,
  slug: string,
  topics: filterType,
): boolean => {
  const indexBestPractices = bestPractices?.data?.findIndex(
    element => element.slug === slug,
  );
  const indexContentTypes = contentTypes?.data?.findIndex(
    element => element.slug === slug,
  );
  const indexTopics = topics?.data?.findIndex(element => element.slug === slug);

  return indexBestPractices > -1 || indexContentTypes > -1 || indexTopics > -1;
};

export const sortByType = (arr: any[], sortByValue: SortByTypes) => {
  if (sortByValue === SortByTypes.None) return arr;

  const [sortByVal, sortDirection] = sortByValue.split('_');
  const directionFactor = sortDirection === 'asc' ? 1 : -1;

  const arrWithIndex = arr.map((item, index) => ({
    ...item,
    originalIndex: index,
  }));

  arrWithIndex.sort((a, b) => {
    const aVal = a[sortByVal];
    const bVal = b[sortByVal];

    // Handle readingTime specially (e.g., "8 min read")
    if (sortByVal === 'readingTime') {
      const aNum = parseFloat((aVal || '').trim().match(/\d+/)?.[0] || '0');
      const bNum = parseFloat((bVal || '').trim().match(/\d+/)?.[0] || '0');
      if (aNum === bNum) {
        return a.originalIndex - b.originalIndex;
      }
      return (aNum - bNum) * directionFactor;
    }

    // For strings/dates/numbers
    if (aVal === bVal) {
      return a.originalIndex - b.originalIndex;
    }

    return (aVal > bVal ? 1 : -1) * directionFactor;
  });

  return arrWithIndex.map(({ originalIndex, ...rest }) => rest);
};
